import { Box, Button, LinearProgress, Typography, useTheme } from "@mui/material";
import React from "react";

const ActionCard = ({
  icon: Icon,
  title,
  description,
  buttonText,
  onClick,
  progress,
  iconColor,
  hoverable = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        height: "152px",
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: theme.palette.background.paper,
        transition: hoverable ? "all 0.2s ease" : "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxSizing: "border-box",
        "&:hover": hoverable
          ? {
              transform: "translateY(-2px)",
              boxShadow: theme.shadows[4],
            }
          : {},
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Box
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            backgroundColor: iconColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon sx={{ color: theme.palette.common.white, fontSize: "20px" }} />
        </Box>
        <Typography variant="h6">{title}</Typography>
      </Box>

      <Typography variant="body2" sx={{ marginBottom: "16px" }}>
        {description}
      </Typography>

      {progress !== undefined ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              flex: 1,
              height: "8px",
              borderRadius: "4px",
              backgroundColor: theme.palette.grey[100],
              "& .MuiLinearProgress-bar": {
                backgroundColor: theme.palette.text.primary,
              },
            }}
          />
          <Button
            variant="outlined"
            sx={{
              color: theme.palette.text.primary,
              borderColor: theme.palette.text.primary,
              height: "40px",
              "&:hover": {
                borderColor: theme.palette.grey[500],
                backgroundColor: theme.palette.grey[25],
              },
            }}
            startIcon={<Icon />}
            onClick={onClick}
          >
            {buttonText}
          </Button>
        </Box>
      ) : (
        <Button
          variant="contained"
          onClick={onClick}
          sx={{
            width: "100%",
            height: "32px",
            padding: "4px 10px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: "8px",
            alignSelf: "flex-start",
            transition: "none",
            animationDuration: "0ms",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
          startIcon={<Icon />}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default ActionCard;
